import { Application } from '@platform/client';
import { OrganizationApplicationParameters, UploadResponse } from '@platform/client/schemas';
import { useState } from 'react';
import { useForm } from 'react-hook-form';
import { ApplicationPageProps } from '../../Application';
import { useApplicationLocalStorage } from '../../application-hook';
import { ApplicationBackground } from '../../ApplicationBackground';
import { ApplicationPageContent } from '../../components/ApplicationPageContent';
import { ProfilePictureUploadButton } from '../../components/ProfilePictureUploadButton';
import BackgroundImage from '../../images/pictureleftside.png';

type FormValues = {
  repProfilePicture: string | null;
};

export const OrgRepProfilePicUpload = (props: ApplicationPageProps) => {
  const { onBack, onContinue, progress } = { ...props };
  const [file, setFile] = useState<File>();
  const { updateApplicationData, getApplicationDataByKey } =
    useApplicationLocalStorage<OrganizationApplicationParameters>();

  const uploadPicture = Application.useUploadProfilePicture();

  const existingPicture = getApplicationDataByKey('repProfilePicture');

  const { handleSubmit } = useForm<FormValues>({
    mode: 'onBlur',
    reValidateMode: 'onChange',
    defaultValues: {
      repProfilePicture: existingPicture || '',
    },
  });

  const submit = () => {
    if (file) {
      uploadPicture.mutate(
        {
          data: {
            file,
          },
        },
        {
          onSuccess: (response) => {
            updateApplicationData({ repProfilePicture: (response as UploadResponse).url || null });
            onContinue();
          },
        },
      );
    } else {
      updateApplicationData({ repProfilePicture: null });
      onContinue();
    }
  };

  return (
    <ApplicationBackground
      progress={progress}
      isOrganization={true}
      onBack={onBack}
      onSubmit={handleSubmit(submit)}
      backgroundImage={BackgroundImage}
      isEditProfile={props.isEditProfile}
    >
      <ApplicationPageContent
        title='Make your profile stand out'
        description="Adding a photo isn't required, but it helps others connect with you more easily"
      >
        <ProfilePictureUploadButton
          file={file}
          setFile={setFile}
          existingPicture={existingPicture}
        />
      </ApplicationPageContent>
    </ApplicationBackground>
  );
};
